import { createContext, FC, ReactNode } from 'react';

type HeaderFooterServerVarsContext = {
    isMobile: boolean;
    isTablet?: boolean;
};

export const HeaderFooterServerVarsContext = createContext<HeaderFooterServerVarsContext>({
    isMobile: false,
});

type Props = {
    children: ReactNode;
    isMobile: boolean;
    isTablet?: boolean;
};

export const HeaderFooterServerVarsContextProvider: FC<Props> = ({
    children,
    isMobile,
    isTablet,
}) => (
    <HeaderFooterServerVarsContext.Provider value={{ isMobile, isTablet }}>
        {children}
    </HeaderFooterServerVarsContext.Provider>
);
